module.exports = __webpack_public_path__ + "img/H1.7a69a72f.png";